"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8.93 11H11V4.07c-1.73.22-3.29.99-4.5 2.13C7.81 7.44 8.69 9.12 8.93 11zM19.93 11c-.15-1.18-.56-2.28-1.16-3.25-.87.87-1.47 1.99-1.68 3.25h2.84zM5.23 7.75c-.6.97-1.01 2.07-1.16 3.25h2.84C6.7 9.74 6.1 8.62 5.23 7.75zM4.07 13c.15 1.18.56 2.28 1.16 3.25.87-.87 1.47-1.99 1.68-3.25H4.07zM6.51 17.79c1.2 1.14 2.76 1.92 4.49 2.14V13H8.93c-.23 1.88-1.12 3.55-2.42 4.79zM17.5 6.2c-1.21-1.14-2.77-1.92-4.5-2.13V11h2.07c.24-1.88 1.12-3.56 2.43-4.8zM18.77 16.25c.61-.96 1.02-2.07 1.16-3.25h-2.84c.21 1.26.81 2.38 1.68 3.25zM13 13v6.93c1.73-.22 3.29-1 4.49-2.14-1.3-1.24-2.19-2.91-2.42-4.79H13z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07c.15-1.18.56-2.28 1.16-3.25zM4.07 13h2.84c-.21 1.26-.81 2.38-1.68 3.25-.6-.97-1.01-2.07-1.16-3.25zM11 19.93c-1.73-.22-3.29-1-4.49-2.14 1.3-1.24 2.19-2.91 2.42-4.79H11v6.93zM11 11H8.93C8.69 9.12 7.81 7.44 6.5 6.2 7.71 5.06 9.27 4.29 11 4.07V11zm8.93 0h-2.84c.21-1.26.81-2.38 1.68-3.25.6.97 1.01 2.07 1.16 3.25zM13 4.07c1.73.22 3.29.99 4.5 2.13-1.31 1.24-2.19 2.92-2.43 4.8H13V4.07zm0 15.86V13h2.07c.24 1.88 1.12 3.55 2.42 4.79-1.2 1.14-2.76 1.92-4.49 2.14zm5.77-3.68c-.87-.86-1.46-1.99-1.68-3.25h2.84c-.15 1.18-.56 2.28-1.16 3.25z"
})), 'SportsBasketballTwoTone');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/SportsBasketballTwoTone.js
// module id = 5486
// module chunks = 0